"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import InputField from "../ui/InputField";
import TextareaField from "../ui/TextareaField";
import Button from "../ui/buttons";
export default function Form() {
  const $ = _c(13);
  const [msg, setMsg] = React.useState("");
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  let t0;
  if ($[0] !== msg) {
    t0 = <TextareaField placeholder={"\u0B92\u0BB0\u0BC1 \u0B95\u0BB0\u0BC1\u0BA4\u0BCD\u0BA4\u0BC8 \u0B8E\u0BB4\u0BC1\u0BA4\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD"} value={msg} onChange={setMsg} height="132px" />;
    $[0] = msg;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== name) {
    t1 = <InputField placeholder={"\u0BAA\u0BC6\u0BAF\u0BB0\u0BCD"} value={name} onChange={setName} height="61px" className="sm:flex-1" />;
    $[2] = name;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== email) {
    t2 = <InputField placeholder={"\u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BCD"} value={email} onChange={setEmail} height="61px" className="sm:flex-1" />;
    $[4] = email;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="flex flex-col sm:flex-row gap-4">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex justify-end"><Button variant="primary" onClick={_temp} className="cursor-pointer">அஞ்சல்</Button></div>;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t0 || $[11] !== t3) {
    t5 = <div className="mx-auto bg-ECEEF3 w-full p-4"><div className="flex flex-col gap-4 h-full">{t0}{t3}{t4}</div></div>;
    $[10] = t0;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp() {}